import TableSearch from '@rio-cloud/rio-uikit/TableSearch';
import type { PropsWithChildren } from 'react';
import { useIntl } from 'react-intl';

export type TableFilterProps = {
    data: any[];
    filter: string;
    setFilter: (filter: string) => void;
    searchByLabel: string;
};

const TableFilter = ({ filter, setFilter, children, searchByLabel }: PropsWithChildren<TableFilterProps>) => {
    const t = useIntl();

    return (
        <div className='align-items-center display-flex justify-content-between' data-testid='table-filter'>
            <div className='min-width-300 margin-right-15'>
                <label className='control-label'>{t.formatMessage({ id: 'general.search' })}</label>
                <TableSearch
                    type='text'
                    id='cardsSearch'
                    value={filter}
                    onChange={setFilter}
                    placeholder={searchByLabel}
                />
            </div>
            {children}
        </div>
    );
};

export default TableFilter;
